var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-headline"},[_c('h4',[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.showReset)?_c('span',{staticClass:"x",on:{"click":_vm.dispatchClick}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }